<template>
  <div class="section-sub-sponsors-wrapper" :class="[{ 'is-alt': isAlt === 'true' }]">

    <!-- background -->
    <div class="background" v-if="isAlt === 'true' && isDesktop">
      <img class="object" src="../assets/car.svg" />
    </div>

    <div class="section-sub-sponsors" id="section-sub-sponsors" data-aos="fade-up" data-aos-once="true">

      <!-- header -->
      <page-subheader :title="title ? title : paragraph.title" :text-align="(level === '0' ? 'left' : 'center')" :title-style="[level === '0' && index !== '1' ? {} : { borderBottom: '0px' }]" style="padding-bottom:0;"></page-subheader>

      <div-container>
        <div v-if="level !== '0'" class="columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile">
          <div v-for="item in items" class="column has-text-left content-images" :class="{ 'is-3 is-6-mobile': true }"><!-- :class="{ 'is-6 is-6-mobile': (level === '1' || level === '2'), 'is-4 is-6-mobile': (level !== '1' && level !== '2') }">-->
            <a class="item" :href="item.link" target="_blank">
              <img :src="item.image.path" class="img-responsive" />
            </a>
          </div>
        </div>
        <!-- <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          <p v-html="error">
          </p>
        </div> -->
        <div-columns v-else paddingTop="1rem" paddingBottom="0">
          <div v-html="paragraph.content" :class="[(isLimitContent ? 'level-0-content' : '')]">
          </div>
        </div-columns>
      </div-container>
    </div>

    <div class="section-sub-sponsors" data-aos="fade-up" data-aos-once="true" v-if="isAlt === 'true' && !isDesktop" style="text-align:right;padding-top:0;">
      <img class="object" src="../assets/car.svg" style="width:400px;" />
    </div>

  </div>
</template>

<script>
  import Site from '@/apis/Site'
  import EventBus from '@/controllers/EventBus'
  import DivContainer from '@/components/DivContainer'
  import DivColumns from '@/components/DivColumns'
  import PageSubheader from '@/components/PageSubheader'
  import ShowDown from 'showdown'
  import 'showdown-target-blank'

  export default {
    name: 'sub-sponsors',
    props: ['level', 'title', 'index', 'is-alt', 'is-limit-content'],
    components: {
      DivContainer,
      DivColumns,
      PageSubheader
    },
    data () {
      return {
        isDesktop: true,
        paragraph: {
          title: '',
          content: ''
        },
        items: [],
        error: undefined,
        loading: false
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
    },
    mounted () {
      // on event resize
      this.isDesktop = EventBus._isDesktop
      EventBus.$on('isDesktopChanged', function () {
        this.isDesktop = EventBus._isDesktop
      }.bind(this))

      this.refresh()
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      getItems: function (onComplete) {
        this.loading = true
        this.error = undefined
        this.paragraph = {
          title: '',
          content: ''
        }
        Site.sponsor(this.level)
        .then((data) => {
          this.loading = false
          // if (this.level === '0') {
          //   console.log(data)
          // }
          if (!data) {
            this.error = 'Unable to load, please kindly refresh the page.'
            return
          }

          // in case level 0
          if (this.level === '0' && this.index) {
            if (data && data.length > 0 && data[this.index].description) {
              var converter = new ShowDown.Converter({ extension: ['targetblank'] })
              var html = converter.makeHtml(data[this.index].description)
              this.paragraph.content = html
              this.items.push(data[0])

              if (!this.title) {
                this.paragraph.title = data[this.index].title
              }
            }
            return
          }

          this.items = data
        })
        .catch((error) => {
          this.loading = false
          this.error = 'Unable to load, please kindly refresh the page.'
          console.log(error)
        })
      },

      refresh: function () {
        this.getItems()
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section sponsors

.section-sub-sponsors-wrapper {
  position: relative;
  background-color: $color-beige;
  &.is-alt {
    background-color: $color-orange;
  }

  .background {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    overflow:hidden;
    padding-top: 3em;
    padding-bottom: 3em;

    .object {
      position: absolute;
      top: 320px;
      right: -80px;
      height: 30%;
      max-height: 200px;

      @media screen and (min-width: $tablet) {
        top: 340px;
        right: 0%;
        height: 40%;
        max-height: 300px;
      }

      @media screen and (min-width: $desktop) {
        top: 300px;
        right: 0%;
        height: 50%;
        max-height: 400px;
      }

      @media screen and (min-width: $fullhd) {
        top: 300px;
        right: 0%;
        height: 70%;
        max-height: 500px;
      }
    }
  }
}

.section-sub-sponsors {
  padding-top: 3rem;
  padding-bottom: 3rem;

  // .title:not(:last-child),
  // .subtitle:not(:last-child) {
  //   padding-left: 0.75em;
  //   padding-right: 0.75em;
  //   margin-bottom: 0.1em;
  // }
  //
  // .title:last-child,
  // .subtitle:last-child {
  //   padding-left: 0.75em;
  //   padding-right: 0.75em;
  //   margin-bottom: 1em;
  // }

  p {
    font-size: 1em;
    text-align: left;
    // padding-left: 0.75em;
    // padding-right: 0.75em;

    &:not(:first-child) {
      margin-top: 1em;
      @media screen and (min-width: $tablet) {
        margin-top: 1em;
      }
    }
  }

  .columns.is-gapless:not(:last-child) {
    margin-bottom: 0;
  }

  .columns.is-gapless > .column {

    &.content-images {
      // background-color: white;
      padding: 30px 0px;

      @media screen and (min-width: $tablet) {
        padding: 20px 0px;
      }

      img {
        display: block;
        margin-left: auto;
        margin-right: auto;
      }

      a.item {
        display: inline-block;
        position: relative;

        img {
          width: 100%;
          // opacity: 0.6;
          // filter: alpha(opacity=60);
          transition: all .2s ease-in-out;
        }

        &:hover {
          img {
            // opacity: 1.0;
            // filter: alpha(opacity=100);
            transform: scale(1.1);
          }
        }
      }
    }

    &.content {
      // background-color: white;
      padding: 30px 15px;

      @media screen and (min-width: $tablet) {
        padding: 30px 15px;
      }

      img {
        display: block;
        margin-left: auto;
        margin-right: auto;
      }

      p, li, h1, h2, h3, h4, h5, h6, strong {
        color: $color-darkbrown;
      }

      p, li {
        line-height: 1.6em;
      }

      h1, h2, h3, h4, h5, h6 {
        font-family: $font-family-title;
        font-weight: bold;
        text-transform: uppercase;

        // &:not(:first-child) {
        //   margin-top: 2rem;
        // }
        // margin-bottom: 1rem;
        //
        // @media screen and (min-width: $tablet) {
        //   &:not(:first-child) {
        //     margin-top: 3rem;
        //   }
        //   margin-bottom: 2rem;
        // }

        &:not(:first-child) {
          margin-top: 0;
        }

        a {
          margin-left: 30px;
        }
      }

      h1, h2 {
        &:not(:first-child) {
          margin-top: 0rem;
        }
      }
    }
  }

  ul {
    list-style: disc;
    margin-left: 2em;
  }

  .level-0-content {
    max-width: 100%;

    @media screen and (min-width: $tablet) {
      max-width: 100%;
    }

    @media screen and (min-width: $desktop) {
      max-width: 80%;
    }

    @media screen and (min-width: $fullhd) {
      max-width: 55%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// SponsorsSubSection.vue?448e5814